import React from 'react';
import PropTypes from 'prop-types';
import { ErrorPage as LaLigaErrorPage } from '@laliga-cdac2/react';
import { useTranslation } from 'react-i18next';

const Fallback = props => {
  const { title, description, ...restProps } = props;
  const { t } = useTranslation();
  return (
    <LaLigaErrorPage
      title={title || t('fallBackErrorTitle')}
      description={description || t('fallBackErrordeDesc')}
      {...restProps}
    />
  );
};

Fallback.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

Fallback.defaultProps = {
  title: null,
  description: null,
};

export default Fallback;
